import { render, staticRenderFns } from "./AlbumForm.vue?vue&type=template&id=18065c09&scoped=true"
import script from "./AlbumForm.vue?vue&type=script&lang=ts"
export * from "./AlbumForm.vue?vue&type=script&lang=ts"
import style0 from "./AlbumForm.vue?vue&type=style&index=0&id=18065c09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18065c09",
  null
  
)

export default component.exports